import { render, staticRenderFns } from "./StudentManage.vue?vue&type=template&id=8b75e19c&scoped=true"
import script from "./StudentManage.vue?vue&type=script&lang=js"
export * from "./StudentManage.vue?vue&type=script&lang=js"
import style0 from "./StudentManage.vue?vue&type=style&index=0&id=8b75e19c&prod&scoped=true&lang=css"
import style1 from "./StudentManage.vue?vue&type=style&index=1&id=8b75e19c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b75e19c",
  null
  
)

export default component.exports